import { useTranslation } from "react-i18next";
import MarketplaceIcon from "@components/MarketplaceIcon";
import {
  MultiSelectOption,
  MultiSelectOptionProps,
  ValueComponentProps,
} from "@components/MultiSelect";
import MultiSelectFilter from "../Filter/MultiSelectFilter";
import styles from "./MarketplaceFilter.module.css";

const OptionComponent = ({ id, value }: MultiSelectOptionProps<string>) => (
  <>
    <MarketplaceIcon marketplace={id} />
    <span>{value}</span>
  </>
)

const ValueComponent = ({ values, options }: ValueComponentProps<string>) => {
  const { t } = useTranslation();
  return (
    <>
      {(values?.length && (values?.length < (options || []).length)) ? (
        <>
          <div className={styles.avatars}>
            {values.map((v: MultiSelectOption<string>) => (
              <MarketplaceIcon
                marketplace={v.id}
                key={v.id}
              />
            ))}
          </div>
          {(values?.length > 1) ? null : (
            <span>{values[0]?.value ?? ""}</span>
          )}
        </>
      ) : (
        <div>{t("filters.marketplaceFilter.all")}</div>
      )}
    </>
  )
}

const MarketplaceFilter = ({ onChange, initialValue, asPanel, isFiltered }: {
  onChange: (sellers: string[]) => void,
  initialValue: string[],
  asPanel?: boolean,
  isFiltered?: boolean,
}) => {
  const data = [
    { id: "Ozon", value: "Ozon", },
    { id: "Yandex", value: "Yandex", },
    ...(isFiltered ? [] : [
      { id: "Wildberries", value: "Wildberries", },
      // { id: "Unknown", value: "Unknown", },
      // { id: "Shopotam", value: "Shopotam", },
      { id: "Aliexpress", value: "Aliexpress", },
    ]),
  ];

  return (
    <MultiSelectFilter
      onChange={onChange}
      initialValue={initialValue}
      ValueComponent={ValueComponent}
      OptionComponent={OptionComponent}
      isFetching={false}
      data={data || []}
      asPanel={asPanel}
    />
  );
}

export default MarketplaceFilter;
